import { apiPrivateAxios } from "../../axios";
import { Order } from "../../../store/types/common";
import {
  IGetAllAssignments,
  IAssignments,
  IHistory,
  IRequestOptimizedClinicians,
  IOptimizedClinicianResponseDto,
  ISaveAssignmentSuggestionRequest,
} from "./types";

export const assignmentsOptimizationRequest = {
   getAssignments: (
    params: IGetAllAssignments
  ): Promise<IAssignments> =>
    apiPrivateAxios.get("/assignments-optimization/all-assignments",
      { params }
  ),
  getOptimizedClinicians: (
    params: IRequestOptimizedClinicians
  ): Promise<IOptimizedClinicianResponseDto[]> =>
    apiPrivateAxios.post("/assignments-optimization/optimized-clinicians",
      params
  ),
  getAssignmentsHistory: (): Promise<IHistory> =>
    apiPrivateAxios.get("/assignments-optimization/history", {
      params: { sort: "createDate", order: Order.Desc },
    }),
  saveAssignmentSuggestions: (
    data: ISaveAssignmentSuggestionRequest
  ): Promise<void> => apiPrivateAxios.put("/assignments-optimization", data),
  getAssignmentCsv: (versionId: string): Promise<Blob> =>
    apiPrivateAxios.get("/assignments-optimization/history-csv", {
      params: { versionId },
    }),
};

const assignmentsOptimizationRequestModule = { assignmentsOptimizationRequest };

export default assignmentsOptimizationRequestModule;
